/* eslint-disable max-len */
import { getBudgetService } from '../../services/yclickMaster';
import {
  getMonthlyUbicationDetail as getMonthlyUbicationDetailService,
  updateMonthlyUbicationDetail as updateMonthlyUbicationDetailService,
  postCreateLocation as postCreateLocationService,
  postCalendarData as postCalendarDataService,
  postPendingAuthorizationMonthly as postPendingAuthorizationMonthlyService,
  getPendingAuthorizationMonthlyUbications,
  getDetailsEvents
} from '../../services/monthlyServiceRequest';
import { imputationTypeEnum } from '../../utils/dataStatus';
import { mapperAccountAssignmentObject } from '../../utils/mapper';
import { oYMEventValues } from '../../constants/constants';

const adapterParamsUpdateImputationObject = (wells) =>
  wells.map((well) => ({
    pozoId: well.well.id,
    tipoId: well.imputationType.id,
    objetoId: well.imputationObject.id
  }));
const getPozos = (filteredWells, values) =>
  filteredWells.map((well) => ({
    idSolicitudServicioMensualizadaPozo: well.idMonthlyWellServiceRequest || null,
    idEventoPozo: well.event?.eventoPozoId || values?.ubication.event?.eventoPozoId,
    idPozo: well.well?.value || well.well?.id,
    pozoStr: well.well?.label,
    idEquipo: well.team?.value || well.team?.id || values?.ubication?.team?.id,
    tipoImputacionEnum: well.imputationType?.value || well.imputationType?.id,
    idObjetoImputacion: well.imputationObject?.value || well.imputationObject?.id
  }));

const getUbicacion = (values, isOyM, filteredWells) => ({
  tipoUbicacionEnum: values.ubication.ubicationType?.id,
  ubicacionNombre: values.ubication.ubication?.label,
  idEvento: isOyM
    ? values.ubication?.ubicationType?.tipoNegocio?.evento?.id
    : filteredWells[0]?.event?.id || values.ubication.event?.id,
  idLocacion: values.ubication.ubication?.id,
  eventoNombre: isOyM
    ? oYMEventValues.eventAbreviation
    : filteredWells[0]?.event?.label || values.ubication.event?.label,
  eventoSigla: isOyM
    ? oYMEventValues.eventAbreviation
    : filteredWells[0]?.event?.sigla || values.ubication.event?.sigla,
  pozos: isOyM ? [] : getPozos(filteredWells, values),
  ubicacionTecnica: isOyM
    ? {
        idUbicacion: values.ubication.ubication?.id,
        codigoSapUbicacion: values.ubication.ubication?.codigoSAP,
        idInstalacion: values.ubication.installation?.id,
        instalacionNombre: values.ubication.installation?.nombre,
        codigoSapInstalacion: values.ubication.installation?.codigoSAP,
        idClasificacion: values.ubication.classification?.id,
        clasificacionNombre: values.ubication.classification?.nombre,
        idActivo: values.ubication?.active?.id,
        descripcionActivo: values.ubication?.active?.nombre
      }
    : null
});

const adapterCreateLocation = (values, isOyM) => {
  const filteredWells = values?.imputationObject?.wells?.filter((well) => !well?.eliminado);
  const ubicaciones = [getUbicacion(values, isOyM, filteredWells)];

  return {
    idUnidadNegocio: !isOyM ? values.ubication?.uunn?.id : null,
    unidadNegocioNombre: !isOyM ? values.ubication?.uunn?.label : null,
    ubicaciones,
    idOperacion: isOyM ? values.ubication?.uunn?.id : null,
    operacionNombre: isOyM ? values.ubication?.uunn?.label : null,
    codigoSapOperacion: values.ubication?.uunn?.codigoSAP
  };
};

// Work part
export const getMonthlyUbicationDetail = ({ id, isOyM }) =>
  new Promise((resolve, reject) => {
    getMonthlyUbicationDetailService({ id, isOyM })
      .then((res) => {
        let resBudget;

        if (isOyM) {
          resBudget =
            res?.tipoImputacion.id === imputationTypeEnum.PEP
              ? [getBudgetService(res?.objetoImputacion?.id)]
              : [];
        } else {
          resBudget = res?.pozos?.map((well) =>
            well.tipoImputacion.id === imputationTypeEnum.PEP
              ? getBudgetService(well.objetoImputacion.id)
              : null
          );
        }

        Promise.all(resBudget)
          .then((values) => {
            const wells = mapperAccountAssignmentObject({
              wells: res?.pozos,
              budget: values,
              event: null,
              mensualizada: true,
              isOyM,
              technicalLocation: res?.ubicacionTecnica,
              imputationType: res?.tipoImputacion,
              imputationObject: res?.objetoImputacion,
              objetDetail: res?.detalleObjeto
            });
            const dataAdapter = {
              imputationObject: {
                wells,
                editaPozosLocacion: res?.editaPozosLocacion,
                esSoloAprobador: res?.esSoloAprobador
              }
            };

            resolve(dataAdapter);
          })
          .catch(() => {
            const wells = mapperAccountAssignmentObject({
              wells: res,
              budget: [],
              event: null,
              mensualizada: true
            });

            const dataAdapter = {
              imputationObject: {
                wells
              }
            };

            resolve(dataAdapter);
          });
      })
      .catch((err) => reject(err));
  });

export const updateMonthlyUbicationDetail = (id, params) =>
  new Promise((resolve, reject) => {
    const paramsAfter = adapterParamsUpdateImputationObject(params);

    updateMonthlyUbicationDetailService(id, paramsAfter)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });

export const postCreateLocation = (id, params, isOyM) =>
  new Promise((resolve, reject) => {
    const paramsAfter = adapterCreateLocation(params, isOyM);

    postCreateLocationService(id, paramsAfter)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });

export const postPendingAuthorizationMonthlyUbications = async (id) =>
  new Promise((resolve, reject) => {
    getPendingAuthorizationMonthlyUbications(id)
      .then((data) => {
        const adaptedResponse =
          data?.map((ubication) => ({
            ubicationId: ubication.idUbicacion,
            ubicationName: ubication.ubicacionNombre,
            event: ubication.evento,
            team: ubication.equipo
          })) ?? [];

        resolve(adaptedResponse);
      })
      .catch((err) => reject(err));
  });

export const postCalendarData = async (body) =>
  new Promise((resolve, reject) => {
    postCalendarDataService(body)
      .then((data) => {
        const adaptedResponse = {
          ubicationId: data.idUbicacion,
          firstDate: data.primeraFecha,
          lastDate: data.ultimaFecha,
          calendarDates: data.fechasCalendario
        };

        resolve(adaptedResponse);
      })
      .catch((err) => reject(err));
  });

export const postPendingAuthorizationMonthly = async (body) =>
  new Promise((resolve, reject) => {
    postPendingAuthorizationMonthlyService(body)
      .then((data) => {
        const adaptedResponse = {
          message: data.mensaje,
          allowAuthorization: data.permitirAutorizacion,
          lines: data.costosPendientes ? data.costosPendientes[0]?.lineas : [],
          pendingAmount: data.costosPendientes ? data.costosPendientes[0].montoPendiente : '0,00',
          contieneArchivosAdjuntos: data.costosPendientes[0]?.contieneArchivosAdjuntos,
          objetoImputacion: data.costosPendientes[0]?.objetoImputacion,
          objetoImputacionModificado: data.costosPendientes[0]?.objetoImputacionModificado
        };

        resolve(adaptedResponse);
      })
      .catch((err) => reject(err));
  });

export const getDetailsEventsFunctionAdapter = ({ idSolicitudMensualizada, idUbicacion }) =>
  new Promise((resolve, reject) => {
    getDetailsEvents({ idSolicitudMensualizada, idUbicacion })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
